// src/widgets/quiz/DeleteQuizDialog.jsx
import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
} from '@mui/material';

const DeleteQuizDialog = ({ open, onClose, onConfirm, quiz }) => {
    if (!quiz) return null;

    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>Confirmar exclusão</DialogTitle>
            <DialogContent>
                <Typography>
                    Tem certeza que deseja excluir o quiz{' '}
                    <strong>{quiz.title}</strong>?
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Cancelar</Button>
                <Button onClick={onConfirm} color="error" variant="contained">
                    Excluir
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default DeleteQuizDialog;
